import dateUtil from "../services/DateUtil";

export default function DateFormat({date, format, timezone}) {
    return dateUtil.format(date, format, timezone);
}